<template>
	<v-main>
		<div
			ref="topPage"
			class="head-banner"
		>
			<div class="py-6">
				<v-container class="pa-0">
					<v-row no-gutters>
						<v-col
							xl="8"
							class="mx-auto px-5 px-sm-10"
						>
							<div
								class="d-flex align-start"
								style="white-space: nowrap;"
							>
								<v-btn
									color="#000"
									elevation="0"
									class="mt-n1"
									fab
									x-small
									dark
									:to="{ name: 'index' }"
								>
									<v-icon>mdi-home</v-icon>
								</v-btn>
								<v-divider
									class="mx-2 mt-3"
									style="min-width: 20px; max-width: 20px; border-color: rgba(0, 0, 0, 0.87) !important;"
								/>
								<span>
									Terms and Conditions
								</span>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</div>
		</div>

		<v-container class="pa-0">
			<div class="pa-6 pa-sm-12">
				<h2 class="text-center">
					ข้อกำหนดและเงื่อนไข <span class="red--text">(Terms and Conditions)</span>
				</h2>

				<p class="mt-8">
					ยินดีต้อนรับเข้าสู่เว็บไซต์ tb.co.th หรือ แอปพลิเคชัน The Best Prop. ("แอปพลิเคชัน") หรือ แอปพลิเคชัน Smart Agent System ("แอปพลิเคชัน") ซึ่งพัฒนา จัดการและบริหารงานโดยบริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด (“บริษัท” "เรา" "พวกเรา" หรือ "ของเรา") เป็นบริษัทจดทะเบียนในประเทศไทย ผู้เข้าเยี่ยมชมเว็บไซต์หรือแอปพลิเคชันนี้ จะต้องถูกผูกพันตามข้อกำหนดและเงื่อนไขในเว็บไซต์หรือแอปพลิเคชันนี้ ดังนั้น โปรดอ่านข้อกำหนดและเงื่อนไขเหล่านี้ด้วยความระมัดระวังก่อนทำธุรกรรมใดๆ บนเว็บไซต์หรือแอปพลิเคชันนี้
				</p>

				<p class="mt-8">
					ก่อนใช้บริการเว็บไซต์หรือแอปพลิเคชันนี้ เราขอความร่วมมือจากคุณ กรุณาอ่านข้อกำหนดและเงื่อนไขการใช้บริการของเว็บไซต์หรือแอปพลิเคชันด้านล่างประกอบกับ
					<n-link
						to="/privacy-policy"
						title="Privacy Policy"
						class="red--text"
					>
						นโยบายความเป็นส่วนตัว
					</n-link> ให้ละเอียดถี่ถ้วนและให้ถือว่าการใช้งานเว็บไซต์หรือแอปพลิเคชันนี้ แสดงถึงการยอมรับข้อตกลงและการยินยอมในการปฏิบัติตามข้อกำหนดและเงื่อนไขต่างๆ ด้านล่าง
				</p>

				<div class="mt-8">
					<strong>การใช้งานเว็บไซต์หรือแอปพลิเคชัน</strong>
					<p>เราขอสงวนสิทธิ์ในการเปลี่ยนแปลง แก้ไข หรือลบ ข้อกำหนดต่างๆ ภายในข้อกำหนดและเงื่อนไขการใช้บริการนี้ ได้ตลอดเวลาโดยไม่ต้องแจ้งให้คุณทราบล่วงหน้า ดังนั้น การเข้ามาอ่านข้อกำหนดและเงื่อนไขการใช้บริการของเว็บไซต์หรือแอปพลิเคชันอย่างสม่ำเสมอ จะช่วยให้คุณทราบข้อกำหนดและเงื่อนไขใหม่ๆ อยู่ตลอดเวลา</p>
					<ul class="mt-4 ml-5">
						<li>
							คุณได้ยอมรับว่าทรัพย์สินทางปัญญาทั้งหมดบนเว็บไซต์และแอปพลิเคชันนี้เป็นของ บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด ข้อมูลและสื่อทั้งหมด ซึ่งรวมถึง เนื้อหา, ข้อความ, รูปภาพ, เสียง, วิดีโอ, ซอฟแวร์หรือโปรแกรมทางคอมพิวเตอร์, ภาพกราฟิกทั้งหลาย, เครื่องหมายทางการค้า โลโก้ ไอคอน, รหัส HTML, PHP, JavaScript และรหัสอื่นๆ บนเว็บไซต์หรือแอปพลิเคชันนี้ ได้รับการคุ้มครองตามกฎหมายทรัพย์สินทางปัญญา และไม่อนุญาตให้ทำการตีพิมพ์ แก้ไข คัดลอก ทำซ้ำ ทำสำเนาหรือเปลี่ยนแปลงในทางใดก็ตาม ภายนอกพื้นที่ของเว็บไซต์หรือแอปพลิเคชันนี้โดยไม่ได้รับการอนุญาตเป็นลายลักษณ์อักษรจากของ บริษัท เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด หากคุณละเมิดสิทธิ์เหล่านี้ คุณจะต้องยอมรับว่าเราขอสงวนสิทธิ์ที่จะดำเนินการเรียกร้องทางแพ่ง สำหรับค่าชดเซยเต็มจำนวนที่เกี่ยวข้องกับความเสียหายหรือการสูญเสียที่ได้รับ การละเมิดเหล่านี้ยังอาจถือเป็นความผิดทางอาญา และยังสามารถดำเนินคดีเกี่ยวกับการละเมิดสิทธิ์ทรัพย์สินทางปัญญาตามกฎหมายอย่างถึงที่สุด
						</li>
						<li class="mt-4">
							คุณยินยอมว่าคุณจะไม่ใช้เว็บไซต์และแอปพลิเคชันนี้ หรือบริการต่างๆ ของเรา ดำเนินการใดๆ ในการรวบรวมข้อมูล ของลูกค้าหรือผู้ลงโฆษณา โดยเด็ดขาด
						</li>
						<li class="mt-4">
							คุณยินยอมที่จะไม่กระทำการ และ/หรือ ใช้ซอฟต์แวร์ใดๆ ในการนำข้อมูลและบริการส่วนหนึ่งส่วนใด ของบริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด ไปใช้โดยไม่ได้รับอนุญาตโดยเด็ดขาด
						</li>
						<li class="mt-4">
							เมื่อคุณใช้งานเว็บไซต์หรือแอปพลิเคชันนี้ คุณจะต้องยินยอมให้ บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด รวบรวมข้อมูลเกี่ยวกับคุณและการใช้งานเว็บไซต์และแอปพลิเคชันนี้ ในการใช้ข้อมูลดังกล่าวตามที่ได้ระบุไว้ใน
							<n-link
								to="/privacy-policy"
								title="Privacy Policy"
								class="red--text"
							>
								นโยบายความเป็นส่วนตัวของเรา
							</n-link>
						</li>
						<li class="mt-4">
							คุณยินยอมให้เราใช้ข้อมูลดังกล่าวโดยไม่มีเงื่อนไขใดๆ ทั้งสิ้น และคุณจะใช้งานเว็บไซต์หรือแอปพลิเคชันนี้ตามวัตถุประสงค์ที่ถูกต้องตามกฎหมาย และไม่กระทำการใดๆ เช่น กระทำการใด ที่จะเป็นการล่วงละเมิดสิทธิส่วนบุคคล และ/หรือสิทธิ์ในทรัพย์สินทางปัญญา ทั้งบุคคลภายนอกและ/หรือ ของเรา ไม่ส่งเนื้อหา รวมถึงการนำข้อความ รูปภาพ หรือ ภาพเคลื่อนไหว ที่ไม่เหมาะสมไม่สุภาพ มีลักษณะเสียดสี ก่อให้เกิดความขัดแย้ง เป็นความลับ หรือเป็นเท็จ รวมทั้งข้อความและรูปภาพที่มีลักษณะขัดต่อกฎหมาย กระทบถึงสถาบันอันเป็นที่เคารพ หรือศีลธรรมอันดีของบ้านเมือง เผยแพร่ผ่านบริการของเว็บไซต์หรือแอปพลิเคชันของเรา หรือกระทำการอื่นใดอันอาจก่อให้เกิดความสูญเสีย หรือเสียหายต่อบริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด และ/หรือบุคคลภายนอก หากปรากฏว่ามีการละเมิดเกิดขึ้น คุณยินยอมที่จะรับผิดชอบสำหรับค่าใช้จ่ายทั้งหมดอันเกิดจากการใช้งานของคุณ เราขอสงวนสิทธิ์ ในการลบ ระงับ ข้อความ รูปภาพใด โดยไม่ต้องบอกกล่าวล่วงหน้า และเราไม่ต้องรับผิดชอบในความเสียหายใดๆ ทั้งสิ้น ให้ข้อกำหนดและเงื่อนไขเหล่านี้ ถูกควบคุมและตีความภายใต้กฎหมายของประเทศไทย และในกรณีเกิดข้อพิพาทใดๆ ให้ศาลยุติธรรมของไทยที่มีอำนาจพิจารณาพิพากษาชี้ขาดเงื่อนไขเป็นไปตามที่บริษัทกำหนด ขอสงวนสิทธิ์ยกเลิกหรือเปลี่ยนแปลงโดยไม่ต้องแจ้งให้ทราบล่วงหน้า
						</li>
						<li class="mt-4">
							ในส่วนของข้อมูลในเว็บไซต์หรือแอปพลิเคชันนั้น บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด มีความพยายามในการเก็บรวบรวมข้อมูลให้ล่าสุด ถูกต้อง อยู่ตลอดเวลา อย่างไรก็ตาม บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด ไม่รับประกัน หรือรับรองความถูกต้องของข้อมูล โดยเฉพาะอย่างยิ่ง บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด จะไม่ยอมรับ หรือรับผิดชอบต่อ ข้อผิดพลาดใดๆ หรือการละเลยเนื้อหาในเว็บไซต์หรือแอปพลิเคชันนี้ ไม่ว่าแหล่งข้อมูลเหล่านั้นจะเป็นข้อมูลที่สร้างมาจากผู้ใช้งานของเว็บไซต์หรือแอปพลิเคชันหรือมาจากทางเราเองก็ตาม ซึ่งรวมไปถึง แต่ไม่จำกัดเฉพาะ ความผิดพลาดจากการให้บริการ บทความ รับส่งข้อมูล การกระทำใดๆ ของบริษัท และพันธมิตรทางธุรกิจของบริษัท
						</li>
					</ul>
				</div>

				<p class="mt-8">
					<strong>การจัดส่งข้อมูลในเว็บไซต์หรือแอปพลิเคชัน</strong>
				</p>
				<p>อย่างไรก็ตามเว็บไซต์หรือแอปพลิเคชันของเรา ซึ่งมีหน้าที่เป็นสื่อกลางในการโฆษณาด้านฝากขาย/เช่า อสังหาริมทรัพย์ และนายหน้าอสังหาฯ เพื่อให้คุณใช้บริการได้อย่างสะดวกและปลอดภัย</p>
				<ul class="mt-4 ml-5">
					<li>
						คุณตกลงและยอมรับว่า ข้อมูลทุกชนิดที่คุณจัดส่งให้ บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด จะถือว่าเป็นข้อมูลที่ไม่เป็นความลับ และไม่เป็นกรรมสิทธิ์แต่อย่างใด ทุกสิ่งที่คุณได้จัดส่งให้กับ บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด สามารถใช้ข้อมูลดังกล่าวโดยไม่มีเงื่อนไขใดๆ ทั้งสิ้น
					</li>
					<li class="mt-4">
						คุณจะต้องยอมรับว่าข้อมูลที่คุณได้กรอกข้อมูล เพื่อบันทึกลงในเว็บไซต์หรือแอปพลิเคชันของเรา ไม่ได้เป็นการละเมิดสิทธิ์จากบุคคลที่สาม รวมถึงลิขสิทธิ์, เครื่องหมายการค้า, ความเป็นส่วนตัว หรือสินทรัพย์ที่เป็นสิทธิส่วนบุคคลอื่น คุณจะต้องเป็นผู้รับผิดชอบข้อมูลทั้งหมดแต่เพียงผู้เดียว
					</li>
				</ul>

				<p class="mt-8">
					<strong>การเชื่อมโยงกับเว็บไซต์อื่นๆ</strong>
				</p>
				<p>เว็บไซต์หรือแอปพลิเคชันนี้ อาจมีการเชื่อมต่อกับเว็บไซต์อื่นๆ เพื่อช่วยให้คุณค้นหาเว็บไซต์ บริการ และ/หรือ ผลิตภัณฑ์ที่เกี่ยวข้องได้อย่างรวดเร็วและง่ายด่าย เราไม่มีอำนาจที่จะควบคุมรับรองยืนยันความถูกต้องหรือความน่าเชื่อถือหรือรับผิดชอบในเนื้อหาของเว็บไซต์ของบุคคล ภายนอก หรือการเชื่อมต่อใด ๆ ที่บรรจุอยู่ในเว็บไซต์ของบุคคลภายนอก การตัดสินใจว่าบริการ และ/หรือ ผลิตภัณฑ์ที่นำเสนอผ่านเว็บไซต์เหล่านี้สอดคล้องกับวัตถุประสงค์ของท่านหรือไม่นั้น เป็นความรับผิดชอบของท่านเอง บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด ไม่สามารถควบคุมและจะไม่รับผิดชอบเนื้อหาของเว็บไซต์เหล่านั้นใดๆ ทั้งสิ้น และบริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด ไม่ได้มีส่วน เกี่ยวข้องในการกำหนดถึงการรับประกันใด ๆ หรือต้องรับภาระค่าเสียหายที่เกี่ยวพันกับเจ้าของ หรือผู้ดำเนินงานของเว็บไซต์ใด ๆ (รวมทั้งความเสียหายที่เกิดจากข้ออ้างใด ๆ ก็ตามที่ละเมิด ลิขสิทธิ์หรือทรัพย์สินทางปัญญาประเภทอื่นของเว็บไซต์ของบุคคลที่สามนั้น)</p>

				<p class="mt-8">
					<strong>การปฏิเสธความรับผิดและข้อจำกัดความรับผิด</strong>
				</p>
				<p>คุณจะต้องยอมรับว่า เมื่อคุณเข้าใช้บริการเว็บไซต์หรือแอปพลิเคชันนี้แล้ว คุณต้องรับผิดชอบ ต่อกระทำการใดๆ ที่จะเป็นการล่วงละเมิดสิทธิส่วนบุคคล และ/หรือสิทธิ์ในทรัพย์สินทางปัญญา ทั้งบุคคลภายนอกและ/หรือ ของเรา สำหรับค่าใช้จ่ายทั้งหมดที่จะเกิดขึ้น (ถ้ามี) จากการเข้าใช้งานของคุณ บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด, กรรมการของบริษัท, พนักงานหรือตัวแทนอื่นๆ จะไม่รับผิดชอบต่อความเสียหายใดๆ, ความสูญเสีย, ค่าใช้จ่าย, การเรียกร้องหรือความต้องการใดๆ, ไม่ว่าจะโดยตรง, โดยอ้อม, การชดเชยหรือผลเสียหายที่เกิดขึ้น, ความเกี่ยวข้องกับการใช้งานเว็บไซต์หรือแอปพลิเคชันนี้ของคุณ หรือข้อมูลเนื้อหา, ส่วนประกอบหรือผลิตภัณฑ์ที่รวมอยู่บนเว็บไซต์นี้ หลักเกณฑ์เหล่านี้ อยู่ภายใต้กฎหมายของประเทศไทย หากเกิดข้อพิพาทใดๆ จะได้รับการแก้ไขโดยศาลยุติธรรมของไทยที่มีอำนาจพิจารณาพิพากษาชี้ขาดเป็นไปตามเงื่อนไขที่บริษัทกำหนด</p>

				<p class="mt-8">
					<strong>การเปลี่ยนแปลงข้อกำหนดและเงื่อนไข</strong>
				</p>
				<p>บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด ดำเนินธุรกิจด้านอสังหาริมทรัพย์ ได้มีการพัฒนาอย่างต่อเนื่อง ดังนั้นนโยบายความเป็นส่วนตัว, ข้อกำหนดและเงื่อนไขการใช้บริการ อาจจะมีการเปลี่ยนแปลง แนะนำให้คุณมีการตรวจสอบอย่างต่อเนื่อง</p>

				<p class="mt-8">
					<strong class="red--text">Customer Service Center</strong>
				</p>
				<p>
					The Best Property Co., Ltd.
				</p>
				<p>
					Website :
					<a
						href="https://tb.co.th"
						class="red--text"
					>
						https://tb.co.th
					</a>
				</p>
				<p>
					Line :
					<a
						href="https://line.me/ti/p/~@thebestproperty"
						class="red--text"
						title="ไลท์แชทกับ The Best Property  ไอดี @thebestproperty"
						target="_blank"
					>
						@thebestproperty
					</a>
				</p>
				<p>
					ช่องทางการติดต่อ:
					<a
						href="tel:02-047-4282"
						class="red--text"
					>
						(+66) 02-047-4282
					</a>
				</p>
			</div>
		</v-container>
	</v-main>
</template>

<script>
const doc = 'privacyPolicy'

import { mapGetters } from 'vuex'

export default {
	// scrollToTop: true,
	name: 'PRIVACYPOLICY',
	layout: 'default_2',

	components: {

	},

	async fetch(context) {
		let data = {
			doc,
			fullPath: context.route.fullPath
		}
		await context.store.dispatch('page/initial', data)
	},

	data:() => ({
		loading: false,
	}),

	computed: {
		...mapGetters({
			isMobile: 'isMobile',
			head: 'page/head',
		}),
	},

	watch: {

	},

	created() {

	},

	mounted() {

	},

	methods: {

	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
.head-banner {
	position: relative;

	.red-strip {
		border: solid 2px #c20000;
		width: 40px;
	}
}

</style>
